$(document).ready(function () {
    if ($('#tickets-order-page').length) {
        isPool();
        ticket_plus();
        ticket_minus();
        print_click();
        invoice_click();
        invoice_type_click();
        country_change();
        filter_delivery_types();
        recover_values();
        validation_processing();
        addition_plus();
        addition_minus();
        product_type_click();
        initDiscountCodeCounterClick();

        if (typeof (only_print) != "undefined" && only_print == 1) {
            changePrintClick();
        }

        if (typeof (only_invoice) != "undefined" && only_invoice == 1) {
            changeInvoiceClick();
            changeInvoiceTypeClick();
        }

        addPostalCodeValidation();
        handleDeliverySection();
    }

    agreements.init();
    agreements.setNewsletterState();
});

function addPostalCodeValidation() {
    if (jQuery.validator) {
        jQuery.validator.addMethod("postal_code", function (value, element) {
            return this.optional(element) || /^\d{2}(?:-\d{3})?$/.test(value);
        }, "Wprowadź poprawny kod pocztowy.");
    }
}

function isPool() {
    $('.pool-is-package').on('change', function () {
        var _hasVal = false;
        $('.pool-is-package').each(function () {
            if ($(this).val() > 0) {
                _hasVal = true;
            }
        });

        if (_hasVal) {
            $('#reservation').hide('slow');
//            radio = $("input[name='payment_type'][value='0']");
//            radio.iCheck('check');
            $('#payment_error_msg').show();
        } else {
            $('#reservation').show('slow');
            $('#payment_error_msg').hide();
        }
    })
}

function get_tickets_count(value) {
    var result = 0;
    if ($.isNumeric(value)) {
        result = parseInt(value);
    }
    return result;
}

function ticket_plus() {
    $('.ticket-plus').click(function () {
        var $this = $(this);

        var id = $this.attr('id');
        id = id.substring(5);
        var input = $('#pool_' + id);
        var quantity = get_tickets_count(input.val());
        quantity += 1;

        input.val(quantity).trigger('change');
        update_current_block(id);
        update_cart_block();
        validate_quantity();
        handleDeliverySection();

        sendAddToCartEvent($this.data("gtag-cart-data"), $this.data("fb-cart-data"));

        return false;
    });
}

function ticket_minus() {
    $('.ticket-minus').click(function () {
        var $this = $(this);

        var id = $(this).attr('id');
        id = id.substring(6);
        var input = $('#pool_' + id);
        var quantity = parseInt(input.val());

        if(quantity > 0) {
            sendRemoveFromCartEvent($this.data("gtag-cart-data"), $this.data("fb-cart-data"));
        }

        quantity -= 1;
        if (quantity < 0) {
            quantity = 0;
        }

        input.val(quantity).trigger('change');
        update_current_block(id);
        update_cart_block();
        validate_quantity();
        handleDeliverySection();

        return false;
    });
}

function sendAddToCartEvent(gtagCartData, fbCartData) {
    try {
        gtag("event","add_to_cart", gtagCartData);
    } catch(err) {
        console.log(err);
    }

    try {
        waitForFbq(function () {
            fbq('track', 'AddToCart', fbCartData);
        });
    } catch(err) {
        console.log(err);
    }
}

function sendRemoveFromCartEvent(gtagCartData, fbCartData) {
    try {
        gtag("event","remove_from_cart", gtagCartData);
    } catch(err) {
        console.log(err);
    }

    try {
        waitForFbq(function () {
            fbq('track', 'RemoveFromCart', fbCartData);
        });
    } catch(err) {
        console.log(err);
    }
}

function update_current_block(pool_id) {
    var selector = ".tickets-table-row[data-pool='" + pool_id + "']";
    var current_row = $(selector);
    var ticket_value = current_row.find(".ticket-value").val();
    var price = $('#price_' + pool_id).data('price');

    if (ticket_value == 0) {
        current_row.addClass("inactive");
        current_row.find(".tickets-count").text("0");
        current_row.find(".total-pool-price").text("0");
        current_row.find(".ticket-minus").attr('disabled', true);
        current_row.find(".hpt-data").hide();
    } else {
        current_row.removeClass("inactive");
        current_row.find(".tickets-count").html(ticket_value);
        current_row.find(".total-pool-price").text(ticket_value * price + " " + getCurrencyName());
        current_row.find(".ticket-minus").attr('disabled', false);
        current_row.find(".hpt-data").show();
    }
}

function handleDeliverySection() {
    var printCheckbox = $("#print");
    var checkboxContainer = printCheckbox.parent();

    if (canSetDelivery() == false) {
        printCheckbox.prop("checked", false);
        printCheckbox.attr("disabled", true);

        if (checkboxContainer !== undefined) {
            checkboxContainer.addClass("disabled");
        }

        changePrintClick();
    } else {
        printCheckbox.removeAttr("disabled");

        if (checkboxContainer !== undefined) {
            checkboxContainer.removeClass("disabled");
        }
    }
}

function canSetDelivery() {
    var canDeliverTickets = false;

    $(".ticket-value").each(function () {
        var $this = $(this);

        if (parseInt($this.val()) > 0) {
            if ($this.data("special-e") == false) {
                canDeliverTickets = true;
            }
        }
    });

    return canDeliverTickets;
}

function getCurrencyName() {
    if (typeof (currencyName) != "undefined") {
        return currencyName;
    } else {
        return "zł";
    }
}

function update_cart_block() {
    var total_price = 0;
    var ticketInfoList = [];
    var totalServiceCostsPrice = 0;

    $('.ticket-value').each(function () {
        quantity = parseInt($(this).val());
        if (quantity > 0) {
            id = $(this).attr('id');
            id = id.substring(5);

            numberOfVaccinated = $('#number_of_vaccinated_' + id);
            if (numberOfVaccinated.length > 0) {
                numberOfVaccinated.data('rule-max', quantity);
                numberOfVaccinated.data('rule-required', true);
            }

            name = $('#name_' + id).text();
            price = $('#price_' + id).attr('data-price');
            serviceCostsPrice = $('#price_' + id).attr('data-service-costs-price');

            if (typeof price === 'string') {
                price = price.replace(',', '.');
            }

            if (typeof serviceCostsPrice === 'string') {
                serviceCostsPrice = serviceCostsPrice.replace(',', '.');
            }

            price = parseFloat(price) * quantity;
            serviceCostsPrice = parseFloat(serviceCostsPrice) * quantity;

            ticketInfoList.push({ name: name, price: price, quantity: quantity });

            total_price += price;
            totalServiceCostsPrice += serviceCostsPrice;

        }
    });

    if (typeof (is_discount_code_enabled) != "undefined" && is_discount_code_enabled)
    {
        var discount_code = parseFloat(get_discount_code(total_price));
        if (total_price >= discount_code)
        {
            total_price -= discount_code;
        }
    }

    var serviceCosts = $('#ticketsTable').attr('data-service-costs');

    if (typeof serviceCosts !== 'undefined') {
        serviceCosts = parseFloat(serviceCosts);

        if (serviceCosts === 0) {
            $('.service-costs').hide();
        }
    } else {
        $('.service-costs').hide();
    }

    if ($('#print').is(':checked')) {
        delivery_type_id = $("input[name='delivery_type']:checked").val();
        if (delivery_type_id !== undefined) {
            del_price = $('#del_price_' + delivery_type_id);
            del_price = parseFloat(del_price.attr('data-val'));
            total_price += del_price;
            ticketInfoList.push({name: "Przesyłka", price: del_price, quantity: 1});
        }
    }

    if (total_price == 0) {
        $("#total_price").text(formatPrice(0));
    } else {
        $("#total_price").text(formatPrice(total_price));
    }

    if (totalServiceCostsPrice == 0) {
        $("#service_costs_value").text(formatPrice(0));
    } else {
        $("#service_costs_value").text(formatPrice(totalServiceCostsPrice));
    }

    buildTicketInfoList(ticketInfoList);
}

var formatPrice = function (price) {
    var price = parseFloat(price);
    var symbol = getCurrencyName();

    if (price % 1 != 0) {
        return price.toFixed(2) + " " + symbol;
    }

    return price + " " + symbol;
}

function buildTicketInfoList(ticketInfoList) {
    var html = "";

    if (ticketInfoList.length > 0) {
        for (var i = 0; i < ticketInfoList.length; i++) {
            html += ticketInfo(ticketInfoList[i]);
        }
    }
    $("#tickets-summary").html(html);
}

function ticketInfo(ticketInfo) {
    return "<div class='row'><div class='col-12 col-sm-8 text-left'><small class='tickets-summary-count font-light'>" + ticketInfo.quantity + " x</small><strong>" + ticketInfo.name + "</strong></div><div class='col-12 col-sm-4 font-light'>" + ticketInfo.price + " zł</div></div>";
}

function shipping() {
    if ($('#print').is(':checked')) {
        $("#shipping").show(500);
    } else {
        $("#shipping").hide(500);
        $('#shipping').find('input[type="radio"]').each(function () {
            $(this).removeAttr('checked');
        });
    }
}

function addInvoice() {
    if ($('#want_invoice').is(':checked')) {
        $("#add_invoice").show(500);
    } else {
        $("#add_invoice").hide(500);
        $('#add_invoice').find('input[type="radio"]').each(function () {
            $(this).removeAttr('checked');
        });
    }
}

function changeInvoiceType() {
    if ($('#invoice_company').is(':checked')) {
        $("#company_div").show(500);
        $("#nip_div").show(500);
        $("#name_div").hide(500);
        $("#last_name_div").hide(500);
    } else {
        $("#name_div").show(500);
        $("#last_name_div").show(500);
        $("#company_div").hide(500);
        $("#nip_div").hide(500);
    }
}

function get_discount_code(totalPrice) {
    var result = 0;
    var codeInputs = $("input[name='order_promotion_codes[]']");

    if (codeInputs.length === 0) {
        codeInputs = $("input[name=discount_code]");
    }

    if (codeInputs.length > 0) {
        var codes = [];
        codeInputs.each(function() {
            var code = $(this).val();
            if (code && code !== "") {
                codes.push(code);
            }
        });

        if (codes.length === 0) {
            return 0;
        }

        var url = (typeof checkPromotionCodeAjaxUrl !== 'undefined') ? checkPromotionCodeAjaxUrl : url_check_discount_code;

        var formData = {
            'event_id': $("input[name=event_id]").val(),
            'promotion_codes': codes,
            'total_price': totalPrice || 0
        };

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            async: false,
            success: function (data) {
                var response = $.parseJSON(data);
                result = parseFloat(response.promotion_value) || 0;
            },
            error: function (error) {
                console.log(error);
            }
        })
    }
    return result;
}

function initDiscountCodeCounterClick() {
    $("#discount-code-counter").click(function () {
        update_cart_block();
    });
}

function print_click() {
    $('#print').bind('change', function () {
        changePrintClick();
    });

    $("input[name='delivery_type']").bind('change', function () {
        update_cart_block();
    });
}

function changePrintClick() {
    shipping();
    update_cart_block();

    if ($("#print") && $("#print").length) {
        toggleDeliveryValidation();
    }
}

function toggleDeliveryValidation() {
    if ($("#print").is(":checked")) {
        addDeliveryValidation();
    } else {
        removeDeliveryValidation();
        clearDeliveryValidation();
    }
}

function addDeliveryValidation() {
    if (jQuery.validator) {
        $("#name").rules("add", {required: true, maxlength: 255, minlength: 2});
        $("#address").rules("add", {required: true, maxlength: 255, minlength: 2});
        $('#city').rules("add", {required: true, maxlength: 255, minlength: 2});
        $('#postal_code').rules("add", {required: true, postal_code: true, maxlength: 255, minlength: 2});
        $("input[name='delivery_type']").rules("add", {required: true});
    }
}

function removeDeliveryValidation() {
    if (jQuery.validator) {
        $("#name").rules("remove");
        $("#address").rules("remove");
        $("#city").rules("remove");
        $("#postal_code").rules("remove");
        $("input[name='delivery_type']").rules("remove");
    }
}

function clearDeliveryValidation() {
    $("#shipping .form-group").each(function () {
        $(this).removeClass('has-error');
        $(this).find('.error-message').remove();
    });
}

function invoice_click() {
    $('#want_invoice').bind('change', function () {
        changeInvoiceClick();
    });
}

function changeInvoiceClick() {
    addInvoice();
    update_cart_block();

    if ($("#want_invoice") && $("#want_invoice").length) {
        toggleInvoiceValidation();
    }
}

function invoice_type_click() {
    $('#invoice_company').bind('change', function () {
        changeInvoiceTypeClick();
    });

    $('#invoice_natural_person').bind('change', function () {
        changeInvoiceTypeClick();
    });
}

function changeInvoiceTypeClick() {
    changeInvoiceType();
    update_cart_block();

    if ($("#want_invoice") && $("#want_invoice").length) {
        toggleInvoiceValidation();
    }
}

function toggleInvoiceValidation() {
    if ($("#want_invoice").is(":checked")) {
        addInvoiceValidation();

        if ($("#invoice_company").is(":checked")) {
            addInvoiceCompanyValidation();
        }

        if ($("#invoice_natural_person").is(":checked")) {
            addInvoiceNaturalPersonValidation();
        }
    } else {
        removeInvoiceValidation();
        clearInvoiceValidation();
    }
}

function addInvoiceValidation() {
    if (jQuery.validator) {
        $("#invoice_address").rules("add", {required: true, maxlength: 255, minlength: 2});
        $('#invoice_city').rules("add", {required: true, maxlength: 255, minlength: 2});
        $('#invoice_postal_code').rules("add", {required: true, postal_code: true, maxlength: 255, minlength: 2});
    }
}

function addInvoiceCompanyValidation() {
    if (jQuery.validator) {
        $("#invoice_name").rules("remove");
        $("#invoice_name").val("");
        $("#invoice_company_name").rules("add", {required: true, maxlength: 255, minlength: 2});
        $("#invoice_nip").rules("add", {required: true, maxlength: 255, minlength: 2});
    }
}

function addInvoiceNaturalPersonValidation() {
    if (jQuery.validator) {
        $("#invoice_company_name").rules("remove");
        $("#invoice_nip").rules("remove");
        $("#invoice_company_name").val("");
        $("#invoice_nip").val("");
        $("#invoice_name").rules("add", {required: true, maxlength: 255, minlength: 2});
    }
}

function removeInvoiceValidation() {
    if (jQuery.validator) {
        $("#invoice_name").rules("remove");
        $("#invoice_company_name").rules("remove");
        $("#invoice_nip").rules("remove");
        $("#invoice_address").rules("remove");
        $("#invoice_city").rules("remove");
        $("#invoice_postal_code").rules("remove");
    }
}

function clearInvoiceValidation() {
    $("#add_invoice .form-group").each(function () {
        $(this).removeClass('has-error');
        $(this).find('.error-message').remove();
    });
}

function country_change() {
    $('#country').change(function () {
        $('#shipping').find('input[type="radio"]').each(function () {
            $(this).attr('checked', false);
        });
        filter_delivery_types();
    });
}

function filter_delivery_types() {
    var country = $('select#country option:selected').text();

    if (country !== '') //jest dropdown - są przesyłki poza Polskę
    {
        $('.del_type').each(function () {
            if (is_active_zone(this, country)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
}

function is_active_zone(me, country) {
    return ((($(me).attr('data-value') == '1') && (country == 'Polska')) ||
            (($(me).attr('data-value') != '1') && (country != 'Polska')));
}

function recover_values() {
    if ($('#print').is(':checked')) {
        $('#shipping').show();

        if (country_val != undefined && country_val != '') {
            $('#country option').filter(function () {
                return $(this).html() == country_val;
            }).attr('selected', 'selected');
        } else {
            $('#country option').filter(function () {
                return $(this).html() == 'Polska';
            }).attr('selected', 'selected');
        }

        filter_delivery_types();

        if (del_type != '') {
            del_radio = $("input[name='delivery_type'][value='" + del_type + "']");
            del_radio.attr('checked', 'checked');
        }
    }

    $('.ticket-value').each(function () {
        quantity = parseInt($(this).val());

        var pool_id = $(this).attr('id');
        pool_id = pool_id.substring(5);
        update_current_block(pool_id);
    });
    update_cart_block();
}

function validation_processing() {
    var e = $("#order");
    var r = $(".alert-danger", e);
    var i = $(".alert-success", e);

    if (e.length > 0) {
        e.validate({
            errorElement: "span",
            errorClass: "error-message",
            focusInvalid: !1,
            ignore: "",
            onfocusout: function(element) {
                // Waliduj tylko jeśli pole ma wartość lub było już walidowane
                if ($(element).val() !== '' || $(element).hasClass('error')) {
                    this.element(element);
                }
            },
            onkeyup: false, // Wyłącz walidację podczas pisania
            rules: {
                first_name: {
                    minlength: 2,
                    maxlength: 255,
                    required: !0
                },
                last_name: {
                    minlength: 2,
                    maxlength: 255,
                    required: !0
                },
                client_country_id: {
                    required: !0
                },
                tel: {
                    minlength: 2,
                    maxlength: 15,
                    required: !0
                },
                email: {
                    minlength: 2,
                    maxlength: 255,
                    required: !0,
                    email: true
                },
                email_confirm: {
                    minlength: 2,
                    maxlength: 255,
                    required: true,
                    email: true,
                    equalTo: "#email"
                },
                personal_data_agreement: {
                    required: true
                },
                email_agreement: {
                    required: true
                },
                regulations_agreement: {
                    required: true
                }
            },
            invalidHandler: function (form, validator) {
                i.hide();
                r.show();

                console.log(validator);


                $('html, body').animate({
                    scrollTop: $(".personal-data-container").offset().top}, 1000);
            },
            errorPlacement: function (error, element) {
                // Dodaj span błędu tylko jeśli ma tekst (występuje błąd)
                if (error.text() !== '') {
                    error.appendTo(element.parent());
                }
            },
            highlight: function (e) {
                $(e).closest(".form-group").removeClass("has-success").addClass("has-error")
            },
            unhighlight: function (e) {
                var $element = $(e);
                var $formGroup = $element.closest(".form-group");
                $formGroup.removeClass("has-error");

                // Usuń span błędu jeśli pole jest teraz poprawne
                var errorSpan = $formGroup.find(".error-message");
                if (errorSpan.length && errorSpan.text() === '') {
                    errorSpan.remove();
                }
            },
            success: function (e, r) {
                $(r).closest(".form-group").removeClass("has-error").addClass("has-success");
                // Usuń puste spany błędów po poprawnej walidacji
                var errorSpan = $(r).closest(".form-group").find(".error-message");
                if (errorSpan.length && errorSpan.text() === '') {
                    errorSpan.remove();
                }
            },
            submitHandler: function (e) {
                i.show();
                r.hide();

                if (validate_quantity() == false) {
                    $('html, body').animate({
                        scrollTop: $(".event-container").offset().top
                    }, 1000);
                    return false;
                }

                e[0].submit();
            }
        });
    }
}

function validate_quantity() {
    var valid = true;

    if (typeof isSeatsFeatureEnabled !== 'undefined' && isSeatsFeatureEnabled) {
        return true;
    }

    if (!check_quantity()) {
        valid = false;
        $('#quantity_error_msg').show();
        $('#quantity_error_msg_pkg').show();
    } else {
        $('#quantity_error_msg').hide();
        $('#quantity_error_msg_pkg').hide();
    }

    if (!check_max_quantity()) {
        valid = false;
        $('#max_quantity_error_msg').show();
    } else {
        $('#max_quantity_error_msg').hide();
    }

    if (valid) {
        $('#ticket_fields').removeClass('field-error');
    } else {
        $('#ticket_fields').addClass('field-error');
    }

    return valid;
}

function check_quantity() {
    var total_quantity = 0;
    $('.ticket-value').each(function () {
        quantity = parseInt($(this).val());
        total_quantity += quantity;
    });

    return (total_quantity > 0);
}

function check_max_quantity() {
    var valid = true;
    $('.ticket-value').each(function () {
        quantity = parseInt($(this).val());
        if (quantity > 0) {
            id = $(this).attr('id');
            id = id.substring(5);
            max_pool_quantity = $('#max_pool_quantity_' + id).val();
            max_pool_quantity = parseInt(max_pool_quantity);

            if (quantity < max_pool_quantity) {
                $("#plus_" + id).removeClass("disabled");
                $("#plus_" + id).attr("disabled", false);
            } else {
                $("#plus_" + id).addClass("disabled");
                $("#plus_" + id).attr("disabled", true);

                if (quantity > max_pool_quantity) {
                    valid = false;
                }
            }
        } else {
            id = $(this).attr('id');
            id = id.substring(5);
            max_pool_quantity = $('#max_pool_quantity_' + id).val();

            if (max_pool_quantity > 0) {
                $("#plus_" + id).removeClass("disabled");
            }
        }
    });
    return valid;
}

function addition_plus() {
    $('.addition-plus').click(function () {
        $('.no-tickets-info').hide();
        $('.your-order').show();
        var id = $(this).attr('id');
        id = id.substring(5);
        var input = $('#addition_' + id);
        var quantity = parseInt(input.val());
        quantity += 1;
        input.val(quantity);
        update_cart_block();
        validate_quantity();
        return false;
    });
}

function addition_minus() {
    $('.addition-minus').click(function () {
        var id = $(this).attr('id');
        id = id.substring(6);
        var input = $('#addition_' + id);
        var quantity = parseInt(input.val());
        quantity -= 1;
        if (quantity < 0) {
            quantity = 0;
        }
        input.val(quantity);
        update_cart_block();
        validate_quantity();
        return false;
    });
}

function product_type_click() {
    $("input[type='radio'][name='payment_type']").click(function () {
        if ($(this).val() == "1") {
            $("#delivery").hide();
        } else {
            $("#delivery").show();
        }
    });
}

var agreements = function () {
    var initAgreementsChange = function () {
        $('#regulations_agreement, #email_agreement, #personal_data_agreement').bind('change', function () {
            setNewsletterAgreementState();
        });
    };

    var setNewsletterAgreementState = function () {
        if ($('#regulations_agreement').is(':checked') && $('#personal_data_agreement').is(':checked') && $('#email_agreement').is(':checked')) {
            var withNewsletter = $("#with_newsletter");
            withNewsletter.removeClass("disabled");
            withNewsletter.removeAttr("disabled");
        } else {
            var withNewsletter = $("#with_newsletter");
            withNewsletter.addClass("disabled");
            withNewsletter.attr("disabled", "disabled");
            withNewsletter.removeAttr('checked');
        }
    };

    return {
        init: function () {
            initAgreementsChange();
        },
        setNewsletterState: function () {
            setNewsletterAgreementState();
        }
    }
}();